export enum MyAccountErrorLogKeys {
    EZ_APPLY_CREDIT_CARD = 'MYACCOUNT_EZ_APPLY_CREDIT_CARD',
    FAVORITES = 'MYACCOUNT_FAVORITES_ERROR',
    MYACCOUNT_ACCOUNT_DETAILS = 'MYACCOUNT_ACCOUNT_DETAILS_ERROR',
    MYACCOUNT_ACCOUNT_SETTINGS = 'MYACCOUNT_ACCOUNT_SETTINGS_ERROR',
    MYACCOUNT_ADDRESS_ERROR = 'MYACCOUNT_ADDRESS_ERROR',
    MYACCOUNT_APPOINTMENTS = 'MYACCOUNT_APPOINTMENTS_ERROR',
    MYACCOUNT_BATFITTING = 'MYACCOUNT_BATFITTING_ERROR',
    MYACCOUNT_CONTACT_DETAILS = 'MYACCOUNT_CONTACT_DETAILS_ERROR',
    MYACCOUNT_CONTAINER = 'MYACCOUNT_CONTAINER_ERROR',
    MYACCOUNT_DELETE_LIST = "MYACCOUNT_DELETE_LIST",
    MYACCOUNT_DUPLICATE_LIST_NAME_EXCEPTION = 'DUPLICATE_LIST_NAME_EXCEPTION',
    MYACCOUNT_EXPLICIT_TEXT_EXCEPTION = 'EXPLICIT_TEXT_EXCEPTION',
    MYACCOUNT_GET_ALL_LISTS = 'MYACCOUNT_GET_LIST_ERROR',
    MYACCOUNT_LISTS = 'MYACCOUNT_LISTS',
    MYACCOUNT_LISTS_DASHBOARD = 'MYACCOUNT_LISTS_DASHBOARD',
    MYACCOUNT_LIST_COUNT = 'MYACCOUNT_LIST_COUNT_ERROR',
    MYACCOUNT_LIST_MARK_COMPONENT = 'MYACCOUNT_LIST_MARK_COMPONENT',
    MYACCOUNT_LOYALTY_INFO =  'MYACCOUNT_LOYALTY_INFO_ERROR',
    MYACCOUNT_MFA_ENROLLMENT = 'MYACCOUNT_MFA_ENROLLMENT_ERROR',
    MYACCOUNT_NEW_LIST = 'MYACCOUNT_NEW_LIST_ERROR',
    MYACCOUNT_ORDER_DETAILS = 'MYACCOUNT_ORDER_DETAILS',
    MYACCOUNT_OVER_CAPACITY_EXCEPTION = 'LIST_OVER_CAPACITY_EXCEPTION',
	MYACCOUNT_PARTYSERVICE_GET = 'MYACCOUNT_PARTYSERVICE_GET_ERROR',
	MYACCOUNT_PARTYSERVICE_SAVE = 'MYACCOUNT_PARTYSERVICE_SAVE_ERROR',
    MYACCOUNT_PARTY_ATTRIBUTES_ERROR = 'MYACCOUNT_PARTY_ATTRIBUTES_ERROR',
    MYACCOUNT_POINT_SERVICE = 'MYACCOUNT_POINT_SERVICE_ERROR',
	MYACCOUNT_PURCHASES = 'MYACCOUNT_PURCHASES_ERROR',
	MYACCOUNT_RECOMMENDED_LIST = 'MYACCOUNT_RECOMMENDED_LIST',
    MYACCOUNT_SEND_RESET_LINK = 'MYACCOUNT_SEND_RESET_LINK_ERROR',
    MYACCOUNT_UPDATE_EMAIL = 'MYACCOUNT_UPDATE_EMAIL_ERROR',
    ORDER_HISTORY = 'MYACCOUANT_ORDER_HISTORY',
    PRODUCT_FAVORITES = 'PRODUCT_FAVORITES_ERR',
    SAVE_FOR_LATER = 'LIST_SAVE_FOR_LATER_ERROR',
	SCORECARD_HISTORY = 'MYACCOUNT_SCORECARD_HISTORY_ERR',
}
